import { render, staticRenderFns } from "./AttributeSettingsSelect.vue?vue&type=template&id=4e5cdf39"
import script from "./AttributeSettingsSelect.vue?vue&type=script&lang=js"
export * from "./AttributeSettingsSelect.vue?vue&type=script&lang=js"
import style0 from "./AttributeSettingsSelect.vue?vue&type=style&index=0&id=4e5cdf39&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports